import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null,
  asyncs: {
  }
}, 'inPutAway');

//const actionListAPI = '/salesOrderEnquiry/lookup/action';

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'Line', field: 'Line', type: 'numericColumn', minWidth: 100 },
    {
      headerName: 'Product',
      field: 'ProductDisplay',
      minWidth: 120,
      suppressSorting: true,
      hyperlinkParamGetter: (row) => {
        if (row.data) {
          return {
            ProductId: row.data.Product,
            FieldValue: row.data.ProductDisplay
          };
        } else {
          return null;
        }
      },
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/inventory-enquiry'
      }
    },
    { headerName: 'Product Group', field: 'ProductGroup', suppressSorting: true, minWidth: 120 },
    { headerName: 'Product Description', field: 'ProductDescription', minWidth: 150, suppressSorting: true },
    { headerName: 'Document', field: 'Document', minWidth: 100, suppressSorting: true },
    { headerName: 'Committed', field: 'CommittedQuantityDisplay', type: 'numericColumn', minWidth: 100, suppressSorting: true },
    { headerName: 'User ID', field: 'UserId', type: 'numericColumn', minWidth: 100, suppressSorting: true },
    { headerName: 'Status', field: 'Status', minWidth: 100, suppressSorting: true },
    { headerName: 'Account', field: 'Account', minWidth: 100, suppressSorting: true }
  ],
  Data: [
  ]
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clear:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }

    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.salesOrderEnquiry.inPutAway,
  {
    Data: data => data.Data,
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.salesOrderEnquiry.inPutAway.loading,
  gridOptions: state => state.salesOrderEnquiry.inPutAway.data.gridOptions,
  Columns: state => state.salesOrderEnquiry.inPutAway.data.Columns,
  Actions: state => state.salesOrderEnquiry.inPutAway.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)